import { Vehicle } from '../../../API/types/Vehicles';

export const generatePreviewLicenseNumber = (license: string | undefined): string => {
  if (license?.length) {
    return license;
  }

  return 'Add vehicle license number';
};

export const generatePreviewModel = (model: string | undefined): string => {
  if (model?.length) {
    return model;
  }

  return 'Add vehicle model';
};

export const generateUnassignedVehiclesTitle = (vehicles: Vehicle[] | undefined): string => {
  if (!vehicles?.length) {
    return 'Vehicles';
  }
  const isPlural = vehicles.length === 1;
  return `${vehicles.length} ${isPlural ? 'vehicle' : 'vehicles'}`;
};
